export const CLICK = 'click';
export const CHANGE = 'change';
export const INPUT = 'input';
export const SUBMIT = 'submit';
export const FOCUSOUT = 'focusout';
export const FOCUSIN = 'focusin';
export const ERROR = 'error';
export const UNHANDLED_REJECTION = 'unhandledrejection';
export const HASH_CHANGE = 'hashchange';
export const MOUSEOVER = 'mouseover';
